import React from "react";
import {
  List,
  Datagrid,
  TextField,
  ReferenceField,
  DateField,
  NumberField,
} from "react-admin";
import { makeStyles } from "@material-ui/core/styles";

const useImageFieldStyles = makeStyles((theme) => ({
  image: {
    width: 80,
  },
}));

const TransferOrderList = (props) => {
  return (
    <List {...props}>
      <Datagrid rowClick="edit">
        <ReferenceField
          label="User Name"
          source="userId"
          reference="users"
          resource="users"
        >
          <>
            <TextField source="firstName" /> <TextField source="lastName" />
          </>
        </ReferenceField>
        <TextField source="walletAccount" />
        <NumberField source="amaCoinsToTransfer" />
        <TextField source="status" />
        <DateField source="createdAt" />
      </Datagrid>
    </List>
  );
};

export default TransferOrderList;
